import React, { Fragment, Component } from "react";
import {
  AutoComplete,
  Button,
  Col,
  Input,
  Form,
  Row,
  Spin,
  Select,
  Tooltip,
} from "antd";
import Dropzone from "react-dropzone";
import {
  getAuthHeader,
  handleErrors,
  hasPermission,
} from "../../utils/security";

import { imageUrlPath, urlPath } from "../Settings";

// const urlPath = "https://acc-aanleveren.persgroep.nl/xServer";

const dropZoneStyle = {
  height: "100px",
  height: "70px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "#ececec",
  border: "1px dashed #cecece",
  color: "#999999",
};

const dropZoneStyleDragging = {
  ...dropZoneStyle,
  borderColor: "#999999",
};

const AssetPreviewBlock = ({ asset, replaceAsset }) => {
  const {
    creationdate,
    name,
    bigpreview,
    inputfilename,
    preview,
    size,
    mimetype,
    originalfile,
  } = asset || false;
  const { url } = preview || bigpreview || originalfile || false;
  
  console.log('asset', asset);

  const rowStyle = {
    marginBottom: "10px",
    display: "flex",
    alignItems: "center",
  };

  const colStyle = {
    textAlign: "left",
    padding: "0 20px",
    fontStyle: "italic",
  };

  return asset && url ? (
    <Row style={rowStyle}>
      <Col span={12}>
        <img src={`${imageUrlPath}${url}`} alt={name} />
      </Col>
      <Col span={12} style={colStyle}>
        name: {name} <br />
        size: {size} <br />
        mimetype: {mimetype} <br />
        creationdate: {creationdate} <br />
        <a href="#" onClick={() => replaceAsset(true)}>
          [Replace Asset]
        </a>  <br />
        <a href={`${imageUrlPath}${originalfile.url}`} download={inputfilename}>
          [Download Asset]
        </a>
      </Col>
    </Row>
  ) : null;
};

class NativeTemplateAssetUpload extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    const { childConfig, value } = this.props;
    const { translations } = childConfig;

    const dropTextTranslated = translations.dropAssets;
    const droppingTextTranslated = "Dropping files";
    const dropReplaceTextTranslated = "Drop a new file to replace";
    const droppedTextTranslated = "Please wait";
    const droppedRejectedTranslated = "Sorry, only images are accepted.";
    const droppedErrorUploadedTranslated = "Sorry, only images are accepted.";

    this.state = {
      dropTextTranslated,
      droppingTextTranslated,
      droppedTextTranslated,
      droppedRejectedTranslated,
      dropReplaceTextTranslated,
      droppedErrorUploadedTranslated,
      dropText: value ? dropReplaceTextTranslated : dropTextTranslated,
      disabled: false,
      dragging: false,
      accepted: false,
      dropped: false,
      value: value || false,
      assetDetails: false,
      dropVisible: false,
    };
  }

  getAssetDetails = (assetID) => {
    const { childConfig } = this.props;
    const { dropTextTranslated, dropReplaceTextTranslated } = this.state;
    const { record } = childConfig;
    const { materialSpecificationId } = record;
    if (assetID) {
      console.log(`please get ${assetID}`);
      fetch(`${urlPath}/api/loadassets?matspec=${materialSpecificationId}`, {
        credentials: "include",
        headers: getAuthHeader(),
      })
        .then((response) => response.json())
        .then((response) => {
          const thisAsset =
            response && response.length
              ? response.find((a) => a.id === assetID)
              : false;
          if (thisAsset) {
            this.setState({
              value: thisAsset.id,
              assetDetails: { ...thisAsset },
              dropVisible: false,
              dropText: dropReplaceTextTranslated,
            });
          } else {
            throw Error(`Asset ${assetID} not found in asset list`);
          }
        })
        .catch((e) => {
          console.error("Cannot load assets!", e);
        });
    } else {
      this.setState({
        value: false,
        assetDetails: false,
        dropVisible: true,
        dropText: dropTextTranslated,
      });
    }
  };

  uploadAsset = (file) =>
    new Promise((res, rej) => {
      const { childConfig } = this.props;
      const { dragging, dropped, droppedTextTranslated } = this.state;
      const { record } = childConfig;
      const { materialSpecificationId } = record;
      const formData = new FormData();
      formData.append("matspec", materialSpecificationId);
      formData.append("file", file);

      this.setState({
        dragging: !dragging,
        dropped: !dropped,
        dropText: droppedTextTranslated,
        disabled: true,
      });

      fetch(urlPath + `/api/assetsave`, {
        method: "POST",
        body: formData,
        credentials: "include",
        headers: getAuthHeader(),
      })
        .then((response) => response.text())
        .then((response) => res(response))
        .catch((e) => {
          console.error("Cannot save asset!", e);
          rej(e);
        });
    });

  onDragEnter = (data) => {
    const { dragging, droppingTextTranslated } = this.state;
    console.log("onDragEnter", data);
    this.setState({ dragging: !dragging, dropText: droppingTextTranslated });
  };

  onDragLeave = (data) => {
    const { dragging, dropTextTranslated } = this.state;
    console.log("onDragLeave", data);
    this.setState({ dragging: !dragging, dropText: dropTextTranslated });
  };

  onDrop = (data) => {
    console.log("onDrop", data);
  };

  onDropAccepted = (acceptedFiles) => {
    const { childConfig, label } = this.props;
    const { updateDataBasedOnAssetProvided } = childConfig;
    const {
      dragging,
      dropped,
      droppedTextTranslated,
      dropReplaceTextTranslated,
      droppedErrorUploadedTranslated,
    } = this.state;
    const file = acceptedFiles.find((f) => f);

    this.uploadAsset(file)
      .then((res) => {
        const assetID = parseInt(res, 10);
        const image = new Image();
        image.onload = () => {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            // { src: file.preview, data: reader.result }
            const { width, height } = image;
            updateDataBasedOnAssetProvided({
              Width: width.toString(),
              Height: height.toString(),
              [label]: assetID,
            });
            this.getAssetDetails(assetID);
            this.setState({
              dragging: false,
              dropped: false,
              dropText: dropReplaceTextTranslated,
              disabled: false,
              dropVisible: false,
            });
          };
        };
        image.src = file.preview;
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          dragging: false,
          dropped: false,
          dropText: droppedErrorUploadedTranslated,
          disabled: false,
          dropVisible: true,
        });
      });
  };

  onDropRejected = (data) => {
    const { dragging, dropped, droppedRejectedTranslated } = this.state;
    console.log("onDropRejected", data);
    this.setState({
      dragging: !dragging,
      dropped: !dropped,
      dropText: droppedRejectedTranslated,
      disabled: false,
      dropVisible: true,
    });
  };

  replaceAsset = (replace) => {
    const { dropReplaceTextTranslated, dropTextTranslated } = this.state;
    this.setState({
      dragging: false,
      dropped: false,
      dropText: replace ? dropReplaceTextTranslated : dropTextTranslated,
      disabled: false,
      dropVisible: true,
    });
  };

  componentDidUpdate = (prevProps) => {
    if (this.props.value !== prevProps.value) {
      if (this.props.value) {
        this.getAssetDetails(this.props.value);
      } else {
        this.getAssetDetails(false);
      }
    }
  };

  render() {
    const {
      disabled,
      dragging,
      dropText,
      assetDetails,
      value,
      dropVisible,
    } = this.state;
    console.log(value);

    if (value && !assetDetails) {
      this.getAssetDetails(value);
    }
    if (!value && !assetDetails && !dropVisible) {
      this.replaceAsset(false);
    }

    return (
      <Fragment>
        {value && assetDetails && (
          <AssetPreviewBlock
            asset={assetDetails}
            replaceAsset={this.replaceAsset}
          />
        )}
        <Input value={value} style={{ display: "none" }} />
        <div style={dropVisible ? { display: "block" } : { display: "none" }}>
          <Dropzone
            accept={"image/*"}
            disabled={disabled}
            multiple={false}
            style={dragging ? dropZoneStyleDragging : dropZoneStyle}
            onDragEnter={this.onDragEnter}
            onDragLeave={this.onDragLeave}
            onDrop={this.onDrop}
            onDropAccepted={this.onDropAccepted}
            onDropRejected={this.onDropRejected}
          >
            <span>{dropText}</span>
          </Dropzone>
        </div>
      </Fragment>
    );
  }
}

export default NativeTemplateAssetUpload;



// WEBPACK FOOTER //
// ./src/components/NativeTemplates/NativeTemplateUpload.js